import * as angular from "angular";
import {NotificationsService} from "./notifications.service";
import {NotificationsButtonComponent} from "./button/notifications-button.component";
import {AuthModule} from "../auth/auth.module";

export const NotificationsModule = angular
    .module("app.shared.notifications", [AuthModule])

    .service("notificationsService", NotificationsService)

    .component("notificationsButton", NotificationsButtonComponent)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/notifications/notifications.module.ts